import Footer from "./Footer";
import Navbar from "./Navbar";

export default function SiteLayout({ children }) {
  return (
    <div className="flex min-h-screen flex-col bg-[var(--bg)] text-[var(--ink)]">
      <a className="skip-link" href="#content">
        Skip to content
      </a>
      <Navbar />
      <main id="content" className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
